const roundToNearestN = (value, n = 100) => Math.round(value / n) * n;

module.exports = {
    roundToNearestN,
};
